import type { CSSProperties, PropsWithChildren } from 'react';

interface IOSDeviceProps extends PropsWithChildren {
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  dark?: boolean;
}

/** Rounded device frame for the app content (no fake status bar / home indicator). */
export function IOSDevice({ children, width = '100%', height = '100%', dark = false }: IOSDeviceProps) {
  const radius = 'clamp(0px, 2.8vmin, 48px)';
  return (
    <div
      style={{
        width,
        height,
        maxWidth: '100%',
        flex: 1,
        minHeight: 0,
        alignSelf: 'stretch',
        borderRadius: radius,
        overflow: 'hidden',
        position: 'relative',
        background: dark ? '#000' : '#F2F2F7',
        boxShadow: '0 24px 60px rgba(0,0,0,0.14), 0 0 0 1px rgba(0,0,0,0.1)',
        fontFamily: '-apple-system, system-ui, sans-serif',
        WebkitFontSmoothing: 'antialiased',
      }}
    >
      <div style={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            WebkitOverflowScrolling: 'touch',
            paddingTop: 'env(safe-area-inset-top, 0px)',
            paddingBottom: 'env(safe-area-inset-bottom, 0px)',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
